<!-- Start Blog Area -->
<section class="blog-area with-events pb-100">
    <div class="container">


        <div class="blog-item-list">
            <h2>Xploradoor Recent Activities</h2>

        </div>
        <owl-carousel-o #carousel [options]="blogSlides">
            <ng-container *ngFor="let Content of businessBlogDetailsList; let i = index">
                <ng-template carouselSlide>
                    <div class="item_s">
                        <div class="single-blog-post">
                            <div class="post-image">
                                <a  class="d-block">
                                    <img [src]="Content.uploadedFilesName[0]" alt="image">
                                </a>
                            </div>
                            <!-- <div class="listings-image">
                            <div class="listings-image-slides">
                                <owl-carousel-o [options]="customOptions2">
                                    <ng-template carouselSlide *ngFor="let Image of Content.uploadedFilesName;;">
                                        <div class="single-image">
                                            <img [src]="Image" alt="image" style="height: 260px;">
                                            <a  class="link-btn"></a>
                                        </div>
                                    </ng-template>
                                </owl-carousel-o>
                            </div>
                            <a  class="bookmark-save"><i class="flaticon-heart"></i></a>
                            <a class="category"><i class="flaticon-cooking"></i></a>
                        </div> -->

                        
                            <div class="post-content">
                                <ul class="post-meta d-flex align-items-center">
                                    <li>
                                        <div class="d-flex align-items-center">
                                            <!-- <img [src]="Content.authorImg" alt="image"> -->
                                            <span
                                                style="color: white;">{{Content.AUTHOR_NAME}}</span>
                                        </div>
                                    </li>
                                    <li style="color: white;"><i class="flaticon-calendar"></i>
                                        <!-- {{Content.date}} -->
                                    </li>
                                </ul>
                                <h3><a routerLink="/blog-details"
                                        style="color: white;"
                                        (click)="selectedBlog(Content.BUSINESS_BLOG_ID)"
                                        >{{Content.BLOG_TITLE}}</a>
                                </h3>
                                <a class="link-btn"><i
                                        class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
            <!-- <ng-container *ngFor="let Content of singleBlogPost; let i = index">
                <ng-template carouselSlide>
                    <div class="item_s">
                        <div class="single-blog-post">
                            <div class="post-image">
                                <a  class="d-block">
                                    <img [src]="Content.mainImg" alt="image">
                                </a>
                            </div>
                            <div class="post-content">
                                <ul class="post-meta d-flex align-items-center">
                                    <li>
                                        <div class="d-flex align-items-center">
                                            <img [src]="Content.authorImg" alt="image">
                                            <span
                                                style="color: white;">{{Content.authorName}}</span>
                                        </div>
                                    </li>
                                    <li style="color: white;"><i class="flaticon-calendar"></i>
                                        {{Content.date}}
                                    </li>
                                </ul>
                                <h3><a routerLink="/{{Content.link}}"
                                        style="color: white;">{{Content.title}}</a>
                                </h3>
                                <a routerLink="/{{Content.link}}" class="link-btn"><i
                                        class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container> -->
        </owl-carousel-o>

        <div class="blog-item-list pt-5">
            <h2 class="pt-3">Subscription</h2>

            <!-- <form [formGroup]="stripeTest" (ngSubmit)="createToken()">
                <label for="name">Name</label>
                <input id="name" formControlName="name" placeholder="Name" />
              
                <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions"></ngx-stripe-card>
              
                <button type="submit" [disabled]="stripeTest.invalid">Pay</button>
              </form> -->

        </div>
        <div class="row gap-30" >
            <div class="col-12 col-md-6 col-lg-4">
                <div class="single-category-box">
                    <!-- Subscription Box Content -->
                    <div class="subscription-card basic">
                        <p style="color: black;">Basic</p>
                        <p class="price">$10/month</p>
                        <ul class="features">
                            <li><span>✅</span><span class="text">Unlimited posts</span></li>
                            <li><span>✅</span><span class="text">Unlimited listings</span></li>
                            <li><span>✅</span><span class="text">Access your reviews</span></li>
                            <li><span>✅</span><span class="text">Invitations to events</span></li>
                            <li><span>❌</span><span class="text" style="color: blue; text-decoration: line-through;">Email marketing</span></li>
                            <li><span>❌</span><span class="text" style="color: blue; text-decoration: line-through;">Calendar for bookings/reservations</span></li>
                            <li><span>❌</span><span class="text" style="color: blue; text-decoration: line-through;">Monthly assessment/analytics</span></li>
                            <li><span>❌</span><span class="text" style="color: blue; text-decoration: line-through;">One time video promo, and photography</span></li>
                        </ul>
                        <button class="subscribe-btn" 
                        (click)="isPublicUser == true ? userToken() : SubscribePlan('Basic')"
                        >Subscribe</button>
                    </div>
                    
                    <!-- Subscription Text (New Addition) -->
                
                </div>
            </div>

            <!-- <div class="col-12 col-md-6 col-lg-4">
                <div class="subscription-card basic">
                    <h3>Basic</h3>
                    <p class="price">$10/month</p>
                    <ul class="features">
                        <li><span class="icon">✅</span><span class="text">Unlimited posts</span></li>
                        <li><span class="icon">✅</span><span class="text">Unlimited listings</span></li>
                        <li><span class="icon">✅</span><span class="text">Access your reviews</span></li>
                        <li><span class="icon">✅</span><span class="text">Invitations to events</span></li>
                        <li><span class="icon">❌</span><span class="text" style="color: blue; text-decoration: line-through;">Email marketing</span></li>
                        <li><span class="icon">❌</span><span class="text" style="color: blue; text-decoration: line-through;">Calendar for bookings/reservations</span></li>
                        <li><span class="icon">❌</span><span class="text" style="color: blue; text-decoration: line-through;">Monthly assessment/analytics</span></li>
                        <li><span class="icon">❌</span><span class="text" style="color: blue; text-decoration: line-through;">One time video promo, and photography</span></li>
                    </ul>
                    <button class="subscribe-btn" (click)="SubscribePlan('Basic')">Subscribe</button>
                  </div>
            </div> -->
            <div class="col-12 col-md-6 col-lg-4">
                <div class="single-category-box">
                <div class="subscription-card enterprise">
                    <p style="color: black;">Standard</p>
                    <p class="price ">$50/month</p>
                    <ul class="features">
                        <li><span>✅</span><span class="text">Unlimited posts</span></li>
                        <li><span>✅</span><span class="text">Unlimited listings</span></li>
                        <li><span>✅</span><span class="text">Access your reviews</span></li>
                        <li><span>✅</span><span class="text">Invitations to events</span></li>
                        <li><span>✅</span><span class="text">Email marketing</span></li>
                        <li><span>✅</span><span class="text" >Calendar for bookings/reservations</span></li>
                        <li><span>❌</span><span class="text" style="color: blue; text-decoration: line-through;">Monthly assessment/analytics</span></li>
                        <li><span>❌</span><span class="text" style="color: blue; text-decoration: line-through;">One time video promo, and photography</span></li>
                    </ul>
                    <!-- <google-pay-button 
                    environment="TEST" 
                    [buttonColor]="buttonColor" 
                    [buttonType]="buttonType"
                    [buttonSizeMode]="isCustomSize ? 'fill' : 'static'" 
                    [paymentRequest]="paymentRequest" 
                    [style.width.px]="buttonWidth"
                    [style.height.px]="buttonHeight" 
                    (loadpaymentdata)="onLoadPaymentData($event)">
                  </google-pay-button> -->
                    <button class="subscribe-btn" 
                    (click)="isPublicUser == true ? userToken() : SubscribePlan('Enterprise')"
                  >Subscribe</button>
                  </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="single-category-box">
                <div class="subscription-card premium">
                    <p style="color: black;">Premium</p>
                    <p class="price">$75/month</p>
                    <ul class="features">
                        <li><span>✅</span><span class="text">Unlimited posts</span></li>
                        <li><span>✅</span><span class="text">Unlimited listings</span></li>
                        <li><span>✅</span><span class="text">Access your reviews</span></li>
                        <li><span>✅</span><span class="text">Invitations to events</span></li>
                        <li><span>✅</span><span class="text">Email marketing</span></li>
                        <li><span>✅</span><span class="text">Calendar for bookings/reservations</span></li>
                        <li><span>✅</span><span class="text">Monthly assessment/analytics</span></li>
                        <li><span>✅</span><span class="text">One time video promo, and photography</span></li>
                    </ul>
                    <button class="subscribe-btn" 
                    (click)="isPublicUser == true ? userToken() : SubscribePlan('Premium')"
                   >Subscribe</button>
                  </div>
                </div>
            </div>
            </div>
          

    </div>
</section>
<!-- End Blog Area -->